<script>
import { mapGetters } from 'vuex';
import SLSMarcaService from '@/services/SistemaDKP/sls-marca.service';
import { BOverlay, BPagination, BFormSelect } from 'bootstrap-vue';
// import ProductionItem from '@/views/app/CartECommerce/catalogo-produtos/ProductionItem.vue';
import _ from 'lodash';
import SLSEsPrioriService from '@/services/SistemaDKP/SLSEsPriori.service';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

const estoqueService = new SLSEstoqueService();

const slsEsPrioriService = new SLSEsPrioriService();

export default {
  name: 'ProdutosPorMarca',
  components: {
    ProductionItem: () => import('@/views/app/CartECommerce/catalogo-produtos/ProductionItem.vue'),
    BOverlay,
    BPagination,
    BFormSelect,
  },
  data() {
    return {
      showLoading: false,
      codMarca: null,
      currentCategoria: null,
      currentReferencia: '',
      applyingRouteQuery: false,
      slsMarcaService: new SLSMarcaService(),
      currentPage: 1,
      pageSize: 8,
      pageSizeOptions: [
        { value: 8, text: '8 / página' },
        { value: 16, text: '16 / página' },
        { value: 24, text: '24 / página' },
        { value: 48, text: '48 / página' },
      ],
      lastFetchCount: 0,
      totalProducts: 0,
      estoqueMap: {},
      debouncedFiltroBusca: null,
    };
  },
  computed: {
    ...mapGetters('slsMarca', {
      getCatalogMarca: 'getCurrentCatalogoMarca',
    }),
    brandName() {
      return this.getCatalogMarca?.des_marca || 'Catálogo';
    },
    hasCatalogPDF() {
      return this.getCatalogMarca?.caminho_catalogo;
    },
    productsCount() {
      return this.totalProducts || this.$store.getters['slsMarca/getImagensPorMarca']?.length || 0;
    },
    hasActiveFilters() {
      return this.currentCategoria || this.currentReferencia.trim();
    },
    hasNextPage() {
      if (this.totalProducts) {
        return this.currentPage < Math.ceil(this.totalProducts / this.pageSize);
      }
      return this.lastFetchCount === this.pageSize;
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    totalPages() {
      return this.totalProducts ? Math.ceil(this.totalProducts / this.pageSize) : 1;
    },
  },
  methods: {
    // Aplica ?categoria=&referencia= vindos da busca visual/global e executa
    // UMA busca (guarda applyingRouteQuery evita fetchs duplicados dos watchers).
    async applyRouteQueryAndFetch() {
      const { categoria, referencia } = this.$route.query || {};
      this.applyingRouteQuery = true;
      try {
        // Sempre parte do estado limpo: em reuso do componente, um filtro
        // antigo não pode "vazar" para a nova navegação.
        this.currentCategoria = null;
        this.currentReferencia = '';
        if (categoria != null && categoria !== '') {
          const opts = this.$store.getters['slsMarca/getOptionsCategorias'] || [];
          this.currentCategoria = opts.find(
            (c) => String(c.cod_categ ?? c.cod_categoria) === String(categoria),
          ) || null;
        }
        if (referencia != null && referencia !== '') {
          this.currentReferencia = String(referencia);
        }
      } finally {
        // Libera os watchers só após o ciclo reativo em que os valores mudaram.
        this.$nextTick(() => { this.applyingRouteQuery = false; });
      }
      await this.fetchPage(1);
    },
    async fetchPage(page) {
      this.showLoading = true;
      this.currentPage = page;

      try {
        const imageParams = {
          limit: this.pageSize,
          offset: (this.currentPage - 1) * this.pageSize,
          images_limit: 5,
        };

        if (this.currentCategoria) {
          imageParams.cod_categ = this.currentCategoria.cod_categ;
        }

        if (this.currentReferencia.trim()) {
          imageParams.familia_comercial_id = this.currentReferencia.trim();
        }

        if (this.currentCategoria) {
          await this.slsMarcaService.listarReferenciasPorCategoriaCodMarca(
            this.currentCategoria.cod_marca,
            this.currentCategoria.cod_categ,
          );
        }

        const result = await this.slsMarcaService.listarImagensPorMarca(this.codMarca, imageParams);
        const items = Array.isArray(result) ? result : result?.data || [];
        this.lastFetchCount = items.length;
        this.totalProducts = Array.isArray(result) ? items.length : result?.total || items.length;

        const itemIds = items.map(i => i.item_id || i.CodItem).filter(Boolean);
        if (itemIds.length) {
          estoqueService.consultarEstoque(itemIds).then(map => {
            this.estoqueMap = { ...this.estoqueMap, ...map };
          });
        }
      } catch (error) {
        console.error('Erro ao carregar página:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao carregar produtos',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.showLoading = false;
      }
    },
    async onPesquisar() {
      await this.fetchPage(1);
    },
    async onLimparFiltros() {
      this.currentCategoria = null;
      this.currentReferencia = '';
      this.currentPage = 1;

      this.$store.commit('slsMarca/clearImagensPorMarca');
      this.$store.commit('slsMarca/clearReferencias');

      await this.fetchPage(1);
    },
    async onLoadingReferenciasAndCategoria(dataReferencia) {
      this.currentReferencia = dataReferencia?.CodReferencia || '';
      await this.fetchPage(1);
    },
    verificarMarca() {
      if (this.codMarca === null) {
        this.$router.push({ name: 'home' });
      }
    },
    downloadCatalogoPDF() {
      this.verificarMarca();
      const link = document.createElement('a');
      link.href = this.getCatalogMarca.caminho_catalogo;
      link.download = 'catalogo.pdf';
      link.click();
    },
    clearData() {
      this.currentCategoria = null;
      this.currentReferencia = '';
      this.currentPage = 1;
      this.lastFetchCount = 0;
      this.totalProducts = 0;
      this.$store.commit('slsMarca/setCurrentCatalogoMarca', {
        log_img_id: '',
        cod_marca: '',
        caminho: '',
        des_marca: '',
        usuario_id: '',
        usuario_nome: '',
        updated_at: '',
        caminho_catalogo: '',
        caminho_img_footer_principal: '',
        caminho_img_footer_secundaria: '',
        cor_cabecalho_marca: '',
        caminho_img_cabec_marcas: '',
        ordem_visualizacao: '',
      });
    },
    onGoToPreviousPage() {
      if (!this.hasPreviousPage) return;
      this.fetchPage(this.currentPage - 1);
    },
    onGoToNextPage() {
      if (!this.hasNextPage) return;
      this.fetchPage(this.currentPage + 1);
    },
    onPageChange(page) {
      if (!page || page === this.currentPage) return;
      this.fetchPage(page);
    },
    onPageSizeChange(newSize) {
      this.pageSize = newSize;
      this.fetchPage(1);
    },
  },
  watch: {
    currentReferencia() {
      if (this.applyingRouteQuery) return;
      if (!this.debouncedFiltroBusca) return;
      this.debouncedFiltroBusca();
    },
    currentCategoria() {
      if (this.applyingRouteQuery) return;
      this.fetchPage(1);
    },
    // O Vue reutiliza o componente quando o usuário já está no catálogo
    // (mesma rota, outra marca/query) — mounted não roda de novo.
    async $route(to, from) {
      if (to.name !== 'produtos-catalogo-marca') return;
      const marcaMudou = String(to.params.codMarca) !== String(from.params.codMarca);
      const queryMudou = JSON.stringify(to.query) !== JSON.stringify(from.query);
      if (!marcaMudou && !queryMudou) return;
      if (marcaMudou) {
        this.codMarca = to.params.codMarca;
        await Promise.all([
          this.slsMarcaService.obterMarcarPorCodMarca(this.codMarca),
          this.slsMarcaService.listarCategoriasPorMarca(this.codMarca),
        ]);
      }
      await this.applyRouteQueryAndFetch();
    },
  },
  created() {
    this.debouncedFiltroBusca = _.debounce(() => {
      this.fetchPage(1);
    }, 450);
  },
  async mounted() {
    this.showLoading = true;

    try {
      if (typeof this.$route.params.codMarca === 'undefined') {
        this.$router.push({ name: 'home' });
        return;
      }

      this.codMarca = this.$route.params.codMarca;

      await Promise.all([
        slsEsPrioriService.selectPrioridadePedido(),
        this.slsMarcaService.obterMarcarPorCodMarca(this.codMarca),
        this.slsMarcaService.listarCategoriasPorMarca(this.codMarca),
      ]);

      await this.applyRouteQueryAndFetch();
    } catch (error) {
      this.$router.push({ name: 'home' });
    } finally {
      this.showLoading = false;
      this.$nextTick(() => {});
    }
  },
  destroyed() {
    this.clearData();
  },
};
</script>

<template>
  <div class="catalog-page">
    <b-overlay :show="showLoading" spinner-variant="primary" blur="2px" opacity=".85" rounded="sm">

      <nav class="catalog-breadcrumb">
        <router-link :to="{ name: 'home' }" class="breadcrumb-link text-primary">
          <feather-icon icon="HomeIcon" size="14" />
          <span>Home</span>
        </router-link>
        <feather-icon icon="ChevronRightIcon" size="14" class="text-muted" />
        <span class="font-weight-bolder">Catálogo</span>
        <template v-if="brandName !== 'Catálogo'">
          <feather-icon icon="ChevronRightIcon" size="14" class="text-muted" />
          <span class="font-weight-bolder">{{ brandName }}</span>
        </template>
      </nav>

      <header class="catalog-header">
        <div class="header-left">
          <div class="brand-chip" v-if="getCatalogMarca.caminho_img_cabec_marcas">
            <img
              :src="getCatalogMarca.caminho_img_cabec_marcas"
              :alt="brandName"
              class="brand-chip-logo"
            />
          </div>
          <div class="header-text">
            <h1 class="page-title">Catálogo{{ brandName !== 'Catálogo' ? ` — ${brandName}` : '' }}</h1>
            <p class="page-subtitle text-muted mb-0">Filtre por categoria ou referência para encontrar os produtos</p>
          </div>
        </div>
      </header>

      <div class="catalog-action-bar">
        <div class="action-bar-filters">
          <div class="filter-field">
            <label class="filter-label text-primary">Categoria</label>
            <v-select
              v-model="currentCategoria"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="descricao"
              value="cod_categoria"
              :options="$store.getters['slsMarca/getOptionsCategorias']"
              :disabled="codMarca === null"
              placeholder="Selecione uma categoria"
              :clearable="true"
            />
          </div>

          <div class="filter-field">
            <label class="filter-label text-primary">Referência</label>
            <b-form-input
              v-model="currentReferencia"
              placeholder="Digite código ou nome"
              @keyup.enter="onPesquisar"
            />
          </div>

          <div class="filter-buttons">
            <b-button
              variant="primary"
              @click="onPesquisar"
              :disabled="!hasActiveFilters"
            >
              <feather-icon icon="SearchIcon" size="16" />
              <span class="ml-50">Buscar</span>
            </b-button>
            <b-button
              variant="outline-secondary"
              @click="onLimparFiltros"
              :disabled="!hasActiveFilters"
            >
              <feather-icon icon="XIcon" size="16" />
              <span class="ml-50">Limpar</span>
            </b-button>
          </div>
        </div>

        <div class="action-bar-actions">
          <b-button
            v-if="hasCatalogPDF"
            variant="outline-primary"
            @click="downloadCatalogoPDF"
          >
            <feather-icon icon="DownloadIcon" size="16" />
            <span class="ml-50">Baixar Catálogo PDF</span>
          </b-button>
        </div>
      </div>

      <div class="catalog-toolbar">
        <div class="toolbar-left">
          <b-button variant="flat-secondary" :to="{ name: 'home' }">
            <feather-icon icon="ArrowLeftIcon" size="16" />
            <span class="ml-50">Voltar</span>
          </b-button>
        </div>
        <div class="toolbar-right">
          <span class="products-count text-muted" v-if="productsCount">
            <strong class="text-primary">{{ productsCount }}</strong> produto{{ productsCount !== 1 ? 's' : '' }} encontrado{{ productsCount !== 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      <section class="products-section" v-if="!showLoading">
        <div class="products-grid" v-if="productsCount">
          <div
            v-for="(item, index) in $store.getters['slsMarca/getImagensPorMarca']"
            :key="index"
            class="product-grid-item"
          >
            <production-item :produto="item" :estoque-info="estoqueMap[item.item_id || item.CodItem]" />
          </div>
        </div>

        <b-card v-else class="empty-state text-center">
          <div class="empty-icon text-muted mb-1">
            <feather-icon icon="PackageIcon" size="56" />
          </div>
          <h3 class="empty-title">Nenhum produto encontrado</h3>
          <p class="text-muted mb-2">Tente ajustar os filtros ou selecionar outra categoria</p>
          <b-button variant="primary" @click="onLimparFiltros">
            <feather-icon icon="RefreshCwIcon" size="16" />
            <span class="ml-50">Limpar Filtros</span>
          </b-button>
        </b-card>
      </section>

      <div class="catalog-pagination" v-if="productsCount && !showLoading">
        <div class="pagination-info-block">
          <span class="pagination-info text-muted">
            <strong class="text-primary">{{ currentPage }}</strong> de <strong class="text-primary">{{ totalPages }}</strong>
            <span class="ml-50">— {{ productsCount }} item{{ productsCount !== 1 ? 'ns' : '' }}</span>
          </span>
          <div class="page-size-selector">
            <label class="page-size-label text-muted mb-0">Mostrar</label>
            <b-form-select
              :value="pageSize"
              :options="pageSizeOptions"
              size="sm"
              class="page-size-input"
              @change="onPageSizeChange"
            />
          </div>
        </div>
        <b-pagination
          :value="currentPage"
          :total-rows="totalProducts"
          :per-page="pageSize"
          align="center"
          first-number
          last-number
          limit="5"
          class="mb-0"
          @change="onPageChange"
        />
      </div>

    </b-overlay>
  </div>
</template>

<style scoped lang="scss">
.catalog-page {
  min-height: 100vh;
  padding-bottom: 2rem;
  position: relative;
}

.catalog-breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 0.85rem;
  font-weight: 500;
}

.breadcrumb-link {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
}

.catalog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.brand-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 0.5rem;
  border-radius: 12px;
  flex-shrink: 0;
}

.brand-chip-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.page-subtitle {
  font-size: 0.9rem;
}

.catalog-action-bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  flex-wrap: wrap;
  /* Dropdown de categoria precisa abrir ACIMA dos cards de produto. */
  position: relative;
  z-index: 20;
}

.filter-field ::v-deep .v-select {
  position: relative;
  z-index: 30;
}

.filter-field ::v-deep .vs__dropdown-menu {
  z-index: 999;
}

/* Overlay de loading acima de TUDO (barra de filtros, dropdown e cards). */
.catalog-page ::v-deep .b-overlay {
  z-index: 1050 !important;
}
.catalog-page ::v-deep .b-overlay > div {
  z-index: 1050;
}

.action-bar-filters {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
  flex: 1;
  max-width: 260px;
}

.filter-label {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.filter-buttons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.action-bar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.catalog-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
}

.products-count {
  font-size: 0.9rem;
}

.products-section {
  padding: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.product-grid-item {
  animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.empty-state {
  padding: 2rem;
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.catalog-pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem 2rem;
  margin-top: 1rem;
}

.pagination-info-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  width: 100%;
  flex-wrap: wrap;
}

.pagination-info {
  font-size: 0.9rem;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.page-size-label {
  font-size: 0.85rem;
}

.page-size-input {
  width: auto;
  min-width: 130px;
}

@media (max-width: 992px) {
  .catalog-action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .action-bar-filters {
    width: 100%;
  }

  .action-bar-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .filter-field {
    max-width: none;
  }
}

@media (max-width: 768px) {
  .catalog-breadcrumb {
    padding: 0.75rem 1rem;
  }

  .catalog-header {
    padding: 1.25rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .header-left {
    width: 100%;
  }

  .brand-chip {
    width: 56px;
    height: 56px;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .catalog-action-bar {
    padding: 1.25rem 1rem;
  }

  .filter-field {
    min-width: 100%;
  }

  .filter-buttons {
    width: 100%;
    justify-content: stretch;
  }

  .action-bar-actions {
    margin-top: 0.5rem;
  }

  .catalog-toolbar {
    padding: 1rem;
  }

  .products-section {
    padding: 1rem;
  }
}
</style>
